import Header from '../components/Header';
import Footer from '../components/Footer';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <article className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-dark mb-6">
              Cookie Policy
            </h1>
            
            <div className="text-sm text-gray-light mb-8">
              Last updated: 02.12.2025
            </div>
            
            <div className="prose prose-lg max-w-none text-gray-light leading-relaxed space-y-6">
              <p className="text-xl text-gray-medium">
                This Cookie Policy explains how Sceptre Slots uses cookies and similar 
                technologies to recognize you when you visit our website. It explains what 
                these technologies are and why we use them, as well as your rights to control 
                our use of them.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">What Are Cookies?</h2>
              
              <p>
                Cookies are small text files that are placed on your computer or mobile device 
                when you visit a website. They are widely used to make websites work more 
                efficiently and provide information to website owners.
              </p>
              
              <p>
                Cookies allow a website to recognize your device and store some information 
                about your preferences or past actions. This enables websites to remember your 
                actions and preferences over a period of time, so you don't have to keep 
                re-entering them whenever you come back to the site or browse from one page 
                to another.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">How We Use Cookies</h2>
              
              <p>
                We use cookies for several purposes. Essential cookies are necessary for the 
                website to function properly and cannot be switched off in our systems. They 
                are usually set in response to actions made by you, such as setting your 
                privacy preferences or filling in forms.
              </p>
              
              <p>
                We use performance cookies to understand how visitors interact with our website. 
                These cookies help us count visits, identify traffic sources, and understand 
                which pages are most popular. This information helps us improve how our website 
                works.
              </p>
              
              <p>
                Functionality cookies allow the website to remember choices you make and provide 
                enhanced, personalized features. These cookies may remember your language 
                preferences or region to provide a more personalized experience.
              </p>
              
              <p>
                We use targeting cookies to deliver advertisements that are relevant to you and 
                your interests. These cookies may also be used to limit the number of times you 
                see an advertisement and help measure the effectiveness of advertising campaigns.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Types of Cookies We Use</h2>
              
              <h3 className="text-2xl font-bold text-gray-dark mt-8 mb-4">Essential Cookies</h3>
              <p>
                These cookies are strictly necessary for the website to function. They enable 
                core functionality such as security, network management, and accessibility. 
                You cannot opt out of these cookies as they are essential for the website to 
                work properly.
              </p>
              
              <h3 className="text-2xl font-bold text-gray-dark mt-8 mb-4">Analytics Cookies</h3>
              <p>
                We use analytics cookies to understand how visitors use our website. These 
                cookies collect information about how you interact with our website, such as 
                which pages you visit most often and if you get error messages. This helps us 
                improve the website's performance and user experience.
              </p>
              
              <h3 className="text-2xl font-bold text-gray-dark mt-8 mb-4">Marketing Cookies</h3>
              <p>
                Marketing cookies are used to track visitors across websites to display 
                advertisements that are relevant and engaging. These cookies may be set by 
                advertising partners and may be used to build a profile of your interests and 
                show you relevant advertisements on other sites.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Third-Party Cookies</h2>
              
              <p>
                In addition to our own cookies, we may also use various third-party cookies to 
                report usage statistics of the website and deliver advertisements. These third 
                parties may set their own cookies to collect information about your online 
                activities across different websites.
              </p>
              
              <p>
                We use Google Analytics to help us understand how visitors use our website. 
                Google Analytics uses cookies to collect information such as how often users 
                visit the website, what pages they visit, and what other sites they used prior 
                to coming to our website. We use this information to improve our website.
              </p>
              
              <p>
                We may also use cookies from advertising networks and affiliate partners to 
                track referrals and measure the effectiveness of our marketing efforts. These 
                cookies help us understand which casino offers are most popular and which 
                marketing channels are most effective.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Managing Cookies</h2>
              
              <p>
                You have the right to decide whether to accept or reject cookies. You can set 
                or amend your web browser controls to accept or refuse cookies. If you choose 
                to reject cookies, you may still use our website, though some functionality 
                may be limited.
              </p>
              
              <p>
                Most web browsers allow you to control cookies through their settings preferences. 
                However, limiting cookies may impact your experience on our website. You can find 
                out more about managing cookies at www.allaboutcookies.org.
              </p>
              
              <p>
                You can opt out of Google Analytics by installing the Google Analytics Opt-out 
                Browser Add-on, which prevents Google Analytics from sharing information about 
                your visits to our website. You can also opt out of interest-based advertising 
                by visiting www.youronlinechoices.com.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Cookie Duration</h2>
              
              <p>
                Cookies can be either "session" or "persistent" cookies. Session cookies are 
                temporary and are deleted when you close your browser. They allow the website 
                to link your actions during a browser session.
              </p>
              
              <p>
                Persistent cookies remain on your device for a set period or until you delete 
                them. These cookies help us recognize you as a returning visitor and remember 
                your preferences. The length of time a persistent cookie remains on your device 
                depends on the specific cookie and its purpose.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Do Not Track Signals</h2>
              
              <p>
                Some browsers include a "Do Not Track" feature that signals to websites you 
                visit that you do not want to have your online activity tracked. Currently, 
                there is no standard for how to respond to Do Not Track signals, and our 
                website does not respond to these signals.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Updates to This Cookie Policy</h2>
              
              <p>
                We may update this Cookie Policy from time to time to reflect changes in our 
                practices or for other operational, legal, or regulatory reasons. We will notify 
                you of any material changes by posting the new Cookie Policy on this page and 
                updating the "Last updated" date.
              </p>
              
              <p>
                We encourage you to review this Cookie Policy periodically to stay informed 
                about our use of cookies and related technologies. Your continued use of our 
                website after any changes constitutes acceptance of the updated Cookie Policy.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Contact Us</h2>
              
              <p>
                If you have any questions about our use of cookies or this Cookie Policy, 
                please contact us at:
              </p>
              
              <p className="font-semibold">
                Email: info@sceptreslots.com<br />
                Phone: +44 8147 675 497<br />
                Address: London, United Kingdom
              </p>
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default CookiePolicy;

